module.exports = __webpack_public_path__ + "static/media/between.8556f2d8.svg";